import React, { useEffect } from "react";
import Select from "react-select";
import { onlyNumericInput, calculateRentalDuration, comma, uncomma } from "@/utils";
import { originOptions, carYearOptions, chargeRateOptions } from "@/constants/selectOptions";
import { useGetInsuranceCorpQuery } from "@/redux/insuranceCorpApi";
import { useGetRentPriceTableQuery, useLazyGetRentPriceTableQuery } from "@/redux/metaApi";
import {
    useGetCarClassQuery,
    useGetCarGubunQuery,
    useGetCarManufacturerQuery,
    useGetCarModelDetailQuery,
    useGetCarModelQuery,
    useGetCarTrimQuery,
    useGetFuelListQuery,
} from "@/redux/metaApi";
import {formatPhoneNumber} from "../../../utils";

export const InsuranceManagerInfo = ({ formData, handleChange, setFormData }) => {
    const { accidentCar, contracts, contractInsurance, customerName, customerPhone } = formData;
    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>팩스번호</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractInsurance.faxNumber"
                            value={contractInsurance?.faxNumber || ""}
                            placeholder=""
                            onChange={handleChange}
                            onInput={onlyNumericInput}
                            maxLength={11}

                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>담당자</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractInsurance.managerName"
                            value={contractInsurance?.managerName || ""}
                            placeholder=""
                            onChange={handleChange}

                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>담당자 연락처</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractInsurance.managerPhone"
                            value={contractInsurance?.managerPhone || ""}
                            placeholder=""
                            onChange={handleChange}
                            onInput={onlyNumericInput}
                            maxLength={11}

                        />
                    </div>
                </div>
            </div>
        </>
    );
};
